import NewHeader from 'components/NewHeader';
import { AboutCheckoutProduct } from 'components/About';
import backgroundImg from 'public/asset/blog/blog-main-visual.png';
import { PageOuterContainer } from 'components/Common/CommonWrappers';
import FloatingController from 'components/Common/FloatingController';
import Footer from 'components/Footer/Footer';
import { BypassBlock } from 'components/Global';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import { NextSeo } from 'next-seo';
import bluedotMetaImg from 'public/asset/bluedot-metatag-img.png';
import { CommonMainVisual } from 'components/Common/CommonMainVisual';
import { SubtitleM } from 'global-styles';
import EventMainSection from 'components/Event/EventMainSection';

const Index = () => {
  const [$fakeHeaderRef, isFakeHeaderVisible, fakeHeaderEntry] = useInView({
    fallbackInView: true,
  });

  return (
    <EventMainContainer>
      <NextSeo
        title="Event - BLUEDOT"
        description="블루닷의 기술을 현장에서 직접 만나보세요."
        canonical="https://blue-dot.io/event/"
        openGraph={{
          url: 'https://blue-dot.io/event/',
          title: 'Event - BLUEDOT',
          description: '블루닷의 기술을 현장에서 직접 만나보세요.',
          images: [
            {
              url: bluedotMetaImg.src,
              alt: 'BLUEDOT INC.',
              type: 'image/png',
            },
          ],
          siteName: 'BLUEDOT',
        }}
        twitter={{
          handle: '@handle',
          site: '@site',
          cardType: 'summary_large_image',
        }}
      />

      <BypassBlock contentSectionId="#blog-content1" />
      <div className="io-target" ref={$fakeHeaderRef} />

      <NewHeader
        isScrolled={!isFakeHeaderVisible && !!fakeHeaderEntry?.target}
      />
      <CommonMainVisual
        backgroundImageSrc={backgroundImg.src}
        innerContainerTitle={{ en: 'Event', ko: 'Event' }}
        descriptionTextComponent={{
          en: <EN />,
          ko: <KO />,
        }}
      />
      <EventMainSection />

      <AboutCheckoutProduct />
      <Footer />

      <FloatingController isVisible={isFakeHeaderVisible} />
    </EventMainContainer>
  );
};

export default Index;

const EventMainContainer = styled(PageOuterContainer)`
  width: 100%;
`;

const KO = () => (
  <div className="ko-wrapper">
    <SubtitleM>
      <div>블루닷의 기술을 현장에서 직접 만나보세요.</div>
    </SubtitleM>
  </div>
);

const EN = () => (
  <>
    <div className="en-wrapper-pc">
      <SubtitleM>
        <span>Meet BLUEDOT&apos;s technology on the spot.</span>
      </SubtitleM>
    </div>
    <div className="en-wrapper-mo">
      <SubtitleM>
        <span>Meet BLUEDOT&apos;s technology on the spot.</span>
      </SubtitleM>
    </div>
  </>
);
